import { FormQuestion, QuestionType } from "./types/form.js";
import { EmptyGuid, FormGlobalHandlers } from "./types/index.js";
import { resolveAppUrl } from "./app-url-client";

// Welcome to javascript hell
// This file is responsible for handling the form questions and their interactions
//let questionAnswered: number = 0;
//let requiredQuestions: number = 0;

let formQuestions: FormQuestion[] = [];
//@ts-ignore-error ignore
let submitButton: kendo.ui.Button | undefined;
//@ts-ignore-error ignore
let formValidator: kendo.ui.Validator | undefined;
let form: HTMLFormElement;
//@ts-ignore-error ignore
export async function initializeForm(rowKey: string) {
  // CA-1567: was a bare root-relative fetch, which drops the PathBase prefix under a
  // non-root PathBase (e.g. IIS sub-application hosting) -- resolved through the same
  // client-side SSOT the v2 bundle uses instead.
  const resp = await fetch(resolveAppUrl(`/GetFormQuestions?rowKey=${rowKey}`));
  formQuestions = (await resp.json()) as FormQuestion[];
  formQuestions.sort((a, b) => a.QuestionIndex - b.QuestionIndex);

  submitButton = $("#SubmitFormButton").data("kendoButton");
  form = document.getElementById("safetyForm") as HTMLFormElement;
  form.onsubmit = onSafetyFormSubmit;
  // requiredQuestions = formQuestions.filter(
  //   (q) =>
  //     q.QuestionAnswerRequired &&
  //     !q.Hidden &&
  //     q.QuestionAnswerTypeEnum !== QuestionType.TextLabel,
  // ).length;

  //if (requiredQuestions > 0) {
  //  submitButton?.enable(false);
  //}

  analyzeBranching(0, true);
  updateQuestionsLabels();
}

export function onSafetyFormSubmit(e: SubmitEvent) {
  e.preventDefault();
  if (!submitButton) return;

  submitButton.enable(false);
  submitButton.element.text("Submitting...");

  form.action = submitButton?.element.attr("formaction") ?? "";
  form.method = "POST";
  form.submit();
}

export function formValueChange(e: any) {
  //const element = document.getElementById(e.sender.element[0].id)!;
  analyzeBranching(0);
  updateQuestionsLabels();
  handleOtherValueChange(e);
}

// I want to get all possible kendo data types and set it as a parameter
export function onRefreshFormsClick(e: any) {
  const buttonElement = e.sender.element as JQuery<HTMLElement>;
  const elementId = buttonElement.attr("data-element-id");
  const widgetType =
    buttonElement.attr("data-widget-type") ?? "kendoCheckBoxGroup";

  if (!elementId) return;

  const kendoElement = $(`#${elementId}`).data(widgetType);
  if (!kendoElement) return;

  kendoElement.dataSource.read();
  kendoElement.refresh();
}

function handleOtherValueChange(e: any) {
  // requiredQuestions = formQuestions.filter(
  //   (q) =>
  //     q.QuestionAnswerRequired &&
  //     !q.Hidden &&
  //     q.QuestionAnswerTypeEnum !== QuestionType.TextLabel,
  // ).length;

  const element = e.sender.element as JQuery<HTMLElement>;

  const index = Number.parseInt(element.attr("id")!.split("_")[2]);
  const question = formQuestions[index]!;

  if (!question.QuestionAnswerRequired) return; //Not required, no need to track

  const value = e.sender.value();

  if (!value) return;

  let answered = 0;
  for (let i = 0; i < formQuestions.length; i++) {
    const question = formQuestions[i];
    const questionElement = getQuestionElement(question);

    if (
      !questionElement ||
      isHidden(questionElement) ||
      question.QuestionAnswerTypeEnum === QuestionType.TextLabel ||
      question.Hidden ||
      !question.QuestionAnswerRequired
    )
      continue;

    //@ts-ignore-error ignore
    const kendoDataComponent = getKendoComponent($(questionElement));

    if (
      (kendoDataComponent?.val() && kendoDataComponent?.val()) ||
      kendoDataComponent?.data("kendoRadioGroup")?.value() ||
      kendoDataComponent?.data("kendoCheckBoxGroup")?.value().length > 0 ||
      kendoDataComponent?.data("kendoMultiSelect")?.value().length > 0 ||
      kendoDataComponent?.data("kendoUpload")?.getFiles().length > 0
    ) {
      answered++;
    }
  }

  //console.trace("Answered questions:", answered);
  //console.trace("Remaining questions:", requiredQuestions - answered);

  //questionAnswered = answered;

  //if (requiredQuestions === answered) {
  //  submitButton?.enable(true);
  //} else {
  //  submitButton?.enable(false);
  //}
}

//TODO: re-evaluate this complexity of form questions and branching logic
/**
 * Analyzes the branching logic starting from the given question index and
 * sets the visibility of questions based on the answers provided.
 * @param currentQuestionIndex
 */
function analyzeBranching(
  currentQuestionIndex: number,
  clearDeselectedMultiBranchValues = false,
) {
  let nextQuestions: FormQuestion[] = [];
  let setHidden = false;

  // target question visibility driven by MultiSelect/CheckBoxGroup selections
  const multiTargetVisibility = new Map<string, boolean>();

  for (let i = currentQuestionIndex; i < formQuestions.length; i++) {
    const question = formQuestions[i];
    const questionElement = getQuestionElement(question);

    const isQueuedTarget = nextQuestions.some((q) => q.Key === question.Key);
    if (isQueuedTarget) {
      nextQuestions = nextQuestions.filter((q) => q.Key !== question.Key);
      setHidden = nextQuestions.length > 0;
      question.Hidden = false;
    } else {
      question.Hidden = setHidden;
    }

    // Multi-select target visibility overrides default radio-driven visibility
    if (multiTargetVisibility.has(question.Key)) {
      question.Hidden = !multiTargetVisibility.get(question.Key)!;
    }

    if (question.Hidden) hideQuestionElement(i, questionElement);
    else showQuestionElement(i, questionElement);

    if (!question.BranchedQuestion) continue;

    const kendoDataComponent = getBranchingComponent(i, questionElement);
    if (!kendoDataComponent) continue;

    // Hidden non-target branch question should not drive downstream logic
    if (question.Hidden && !isQueuedTarget) {
      clearBranchComponentValue(kendoDataComponent, false);
      continue;
    }

    // MultiSelect / CheckBoxGroup: show only selected target questions, do not jump-hide normal flow
    if (
      kendoDataComponent instanceof kendo.ui.MultiSelect ||
      kendoDataComponent instanceof kendo.ui.CheckBoxGroup
    ) {
      const selectedValues = new Set(
        ((kendoDataComponent.value() as string[]) ?? [])
          .map((v) => v?.trim())
          .filter((v) => !!v),
      );

      const allTargetKeys = new Set(
        question.BranchingInfo.filter(
          (b) => b.BranchedQuestionKey && b.BranchedQuestionKey !== EmptyGuid,
        ).map((b) => b.BranchedQuestionKey.toString()),
      );

      const selectedTargetKeys = new Set(
        question.BranchingInfo.filter(
          (b) =>
            selectedValues.has(b.AnswerOptionValue.toString()) &&
            b.BranchedQuestionKey &&
            b.BranchedQuestionKey !== EmptyGuid,
        ).map((b) => b.BranchedQuestionKey.toString()),
      );

      for (const targetKey of allTargetKeys) {
        multiTargetVisibility.set(targetKey, selectedTargetKeys.has(targetKey));
      }

      // Keep normal flow for non-target questions
      continue;
    }

    // RadioGroup: preserve classic jump branching behavior
    if (kendoDataComponent instanceof kendo.ui.RadioGroup) {
      const selectedValue = kendoDataComponent.value();
      const target = question.BranchingInfo.find(
        (b) => b.AnswerOptionValue.toString() === selectedValue,
      );

      const multiBranchExitQuestion = multiTargetVisibility.has(question.Key)
        ? getNextNonMultiBranchQuestion(i, multiTargetVisibility)
        : undefined;

      if (!target) {
        setHidden = true;
        nextQuestions = [];
        continue;
      }

      if (multiBranchExitQuestion) {
        setHidden = true;
        nextQuestions = [multiBranchExitQuestion];
        continue;
      }

      // "Next question" option remains valid for radio only
      if (
        !target.BranchedQuestionKey ||
        target.BranchedQuestionKey === EmptyGuid
      ) {
        setHidden = false;
        nextQuestions = [];
        continue;
      }

      const nextQuestion = formQuestions.find(
        (q) => q.Key === target.BranchedQuestionKey,
      );

      if (!nextQuestion) {
        setHidden = true;
        nextQuestions = [];
        continue;
      }

      setHidden = true;
      nextQuestions = [nextQuestion];
    }
  }

  if (clearDeselectedMultiBranchValues) {
    clearDeselectedMultiBranchQuestionValues(multiTargetVisibility);
  }
}

function getNextNonMultiBranchQuestion(
  currentQuestionIndex: number,
  multiTargetVisibility: Map<string, boolean>,
): FormQuestion | undefined {
  for (let i = currentQuestionIndex + 1; i < formQuestions.length; i++) {
    const question = formQuestions[i];
    if (!multiTargetVisibility.has(question.Key)) {
      return question;
    }
  }

  return undefined;
}

/**
 *
 * @param index The question index
 * @param questionElement The question element
 * @returns The branching component if found, otherwise undefined
 */
function getBranchingComponent(
  index: number,
  questionElement: HTMLElement | null,
):
  | kendo.ui.RadioGroup
  | kendo.ui.MultiSelect
  | kendo.ui.CheckBoxGroup
  | undefined {
  //@ts-ignore-error hello
  let component:
    | kendo.ui.RadioGroup
    | kendo.ui.MultiSelect
    | kendo.ui.CheckBoxGroup
    | undefined = $(
    `#generalTab_FormQuestionsList_${index}__AnswerDecimal`,
  ).data("kendoRadioGroup");
  if (!component) {
    component = $(
      `#generalTab_FormQuestionsList_${index}__AnswerKeyCollection`,
    ).data("kendoMultiSelect");
  }

  if (!component) {
    component = $(
      `#generalTab_FormQuestionsList_${index}__AnswerStringArray`,
    ).data("kendoCheckBoxGroup");
  }

  if (!component && questionElement) {
    const container = $(questionElement);
    component =
      container
        .find("[data-role='multiselect']")
        .first()
        .data("kendoMultiSelect") ??
      container
        .find("[data-role='checkboxgroup']")
        .first()
        .data("kendoCheckBoxGroup") ??
      container
        .find("[data-role='radiogroup']")
        .first()
        .data("kendoRadioGroup");
  }

  return component;
}

/**
 * Clears the value of the given branching component and triggers a change event to update the form state.
 * @param component The branching component to clear the value of
 */
function clearBranchComponentValue(
  component:
    | kendo.ui.RadioGroup
    | kendo.ui.MultiSelect
    | kendo.ui.CheckBoxGroup,
  triggerChange = true,
) {
  if (
    component instanceof kendo.ui.MultiSelect ||
    component instanceof kendo.ui.CheckBoxGroup
  ) {
    component.value([]);
  } else {
    component.value(null!);
  }

  if (triggerChange) {
    component.trigger("change");
  }
}

function clearQuestionAnswerValue(
  index: number,
  questionElement?: HTMLElement | null,
  triggerChange = true,
) {
  if (!questionElement) return;

  const widgets = getKendoWidgetInstances(questionElement);
  for (const widget of widgets) {
    clearKendoWidgetValue(widget, triggerChange);
  }

  const answerFieldPrefix = `generalTab_FormQuestionsList_${index}__Answer`;

  questionElement
    .querySelectorAll("input, textarea, select")
    .forEach((element) => {
      if (
        element instanceof HTMLInputElement &&
        element.id.startsWith(answerFieldPrefix)
      ) {
        if (element.type === "checkbox" || element.type === "radio") {
          element.checked = false;
        } else if (element.type !== "hidden") {
          element.value = "";
        }
      }

      if (element instanceof HTMLTextAreaElement) {
        element.value = "";
      }

      if (element instanceof HTMLSelectElement) {
        if (element.multiple) {
          Array.from(element.options).forEach((option) => {
            option.selected = false;
          });
        } else {
          element.selectedIndex = -1;
        }
      }
    });
}

function clearDeselectedMultiBranchQuestionValues(
  multiTargetVisibility: Map<string, boolean>,
) {
  for (const [targetKey, isVisible] of multiTargetVisibility.entries()) {
    if (isVisible) continue;

    const targetIndex = formQuestions.findIndex((q) => q.Key === targetKey);
    if (targetIndex < 0) continue;

    clearQuestionAnswerValue(
      targetIndex,
      getQuestionElement(formQuestions[targetIndex]),
      false,
    );
  }
}

function getKendoWidgetInstances(element: HTMLElement): any[] {
  const widgets: any[] = [];
  const seen = new Set<any>();
  const elements = [
    element,
    ...Array.from(element.querySelectorAll("*")),
  ] as HTMLElement[];

  for (const currentElement of elements) {
    try {
      const widget = kendo.widgetInstance($(currentElement));
      if (widget && !seen.has(widget)) {
        seen.add(widget);
        widgets.push(widget);
      }
    } catch {
      continue;
    }
  }

  return widgets;
}

function clearKendoWidgetValue(widget: any, triggerChange = true) {
  if (
    widget instanceof kendo.ui.MultiSelect ||
    widget instanceof kendo.ui.CheckBoxGroup
  ) {
    widget.value([]);
  } else if (
    widget instanceof kendo.ui.TextBox ||
    widget instanceof kendo.ui.TextArea
  ) {
    widget.value("");
  } else if (typeof widget.value === "function") {
    widget.value(null);
  }

  if (triggerChange && typeof widget.trigger === "function") {
    widget.trigger("change");
  }
}

/**
 * Updates the question labels to reflect their current numbering based on visibility.
 */
function updateQuestionsLabels() {
  let currentNumber = 1;

  for (let i = 0; i < formQuestions.length; i++) {
    const currentQuestion = formQuestions[i];
    const questionElement = getQuestionElement(currentQuestion);
    if (
      !questionElement ||
      isHidden(questionElement) ||
      isLabelElement(currentQuestion)
    )
      continue;

    const questionLabelElement = getQuestionLabelElement(currentQuestion);
    if (!questionLabelElement) continue;

    const labelText = `${currentNumber}. ${currentQuestion.QuestionFull}`;
    const textNode = Array.from(questionLabelElement.childNodes).find(
      (node): node is Text => node.nodeType === Node.TEXT_NODE,
    );

    if (textNode) {
      textNode.textContent = labelText;
    } else {
      questionLabelElement.prepend(document.createTextNode(labelText));
    }

    currentNumber++;
  }
}

function isLabelElement(question: FormQuestion) {
  const element = getQuestionElement(question)!;

  return (
    question.QuestionAnswerTypeEnum === QuestionType.TextLabel ||
    element.getAttribute("data-is-label") === "True"
  );
}

/**
 * Gets the question container element from the given question.
 */
function getQuestionElement(question: FormQuestion): HTMLElement | null {
  return document.querySelector(
    `[data-question-index="${question.QuestionIndex}"]`,
  );
}

/**
 * Gets the question container label element from the given question.
 */
function getQuestionLabelElement(question: FormQuestion): HTMLElement | null {
  return document.querySelector(
    `[data-question-index-label="${question.QuestionIndex}"]`,
  );
}

/**
 * Recursively searches for a Kendo component within the given jQuery element.
 * @param element The jQuery element to search for a Kendo component
 * @returns The jQuery element of the Kendo component, or undefined if not found
 */
function getKendoComponent(
  element: JQuery<HTMLElement>,
): JQuery<HTMLElement> | undefined {
  try {
    const kendoDataComponentWidget = kendo.widgetInstance(element);
    const kendoDataComponent = $(kendoDataComponentWidget.element);
    return kendoDataComponent;
  } catch {
    for (const child of element.children()) {
      const kendoDataComponent = getKendoComponent($(child));
      if (kendoDataComponent) return kendoDataComponent;
    }
  }
}

function hideQuestionElement(index: number, element?: HTMLElement | null) {
  if (!element) return;

  const hiddenInput = $(`#generalTab_FormQuestionsList_${index}__Hidden`);

  if (hiddenInput) {
    hiddenInput.val("True");
  }

  element.classList.add("d-none");
}

function showQuestionElement(index: number, element?: HTMLElement | null) {
  if (!element) return;
  if (element.getAttribute("style")) element.removeAttribute("style");
  if (element.getAttribute("hidden")) element.removeAttribute("hidden");
  if (element.classList.contains("d-none")) element.classList.remove("d-none");

  const hiddenInput = $(`#generalTab_FormQuestionsList_${index}__Hidden`);

  if (hiddenInput) {
    hiddenInput.val("False");
  }

  element.querySelectorAll("[data-is-inner-span]").forEach((el) => {
    el.removeAttribute("hidden");
  });
}

function isHidden(element?: HTMLElement) {
  if (!element) return true;
  return (
    element.classList.contains("d-none") ||
    element.getAttribute("hidden") ||
    element.style?.display === "none"
  );
}

Object.assign(globalThis as typeof globalThis & FormGlobalHandlers, {
  formValueChange,
  initializeForm,
  handleOtherValueChange,
  onRefreshFormsClick,
  onSafetyFormSubmit,
});
